// src/usePageTracking.js
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function usePageTracking() {
  const location = useLocation();

  useEffect(() => {
    // gtag may be blocked by an ad blocker, so check before calling it
    if (typeof window.gtag !== 'function') return;

    // Replace with your GA4 measurement ID
    window.gtag('config', 'G-27J4Z4RRNQ', {
      page_path: location.pathname + location.search,
    });
  }, [location]);
}
